export interface GetReturnCollectionRequest {
  collectionId: number
  collectionNo: string
  assignedReserveIds: number[]
}

export function GetReturnCollectionRequestToJSON(
  value: GetReturnCollectionRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined,
    assigned_reserve_ids:
      value.assignedReserveIds.length > 0 ? value.assignedReserveIds : undefined
  }
}
